/**
 * Canonical eight-colour palette for PreTrade charts.
 * Ordered cool→warm so consumers that read it sequentially (e.g. urgency
 * overlays) get a perceptually pleasant gradient. Scenario slot assignment
 * is order-insensitive so this ordering works there too.
 */
export const CHART_PALETTE = [
  '#C084FC', // purple
  '#60A5FA', // blue
  '#34D399', // emerald
  '#FBBF24', // yellow
  '#FB923C', // orange
  '#F87171', // red
  '#A78BFA', // violet
  '#2DD4BF', // teal
] as const;
